export default __webpack_public_path__ + "static/media/login-bg.8724c9d7.jpg";